const optInComplete = 'signupinitiated';
const qualifiedTune = 'qualifiedTune';

export default function ga(...params) {
  if (window.ga) {
    window.ga(...params);
  }
}

export function gaLogOptInComplete(purchasePrice) {
  ga('send', 'event', optInComplete, 'click', 'label', purchasePrice);
}

export function gaReportQualifiedTune() {
  ga('send', 'event', qualifiedTune);
}
